<template>
 <div id="click" class="container">      
       <button type="button" :class="[ ancho ? 'ancho' : 'largo' ]" :disabled="disabled">{{ buttonText }}</button>
    </div>
</template>

<script>
import { RouterLink } from 'vue-router'
export default {
  props: {
    buttonText: {
      type: String,
      default: () => "Label",
    },
    largo: {
      type: Boolean,
      default: () => true,
    },
    ancho: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    }
  }
}

</script>




<style scoped lang="less">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');
.container {
    margin: 15px auto;
    
}
.largo{
    padding: 4px 80px;


}
.ancho {
  padding: 3px 30px;
}

.container button {
     font-family: 'Montserrat';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
    font-weight: 700;
    box-shadow: -2px 3px 3px 1px rgba(208,215,230,255);
    font-size: 18px;
    background-color: #822c30;
    color: rgb(255, 255, 255);
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
    
    
}
.container button.selected {
    background-color: #f7fafc;
    border-color: #fff;
    
    
}


h1 {
  margin: 30px 0 0;
  
}
ul {
  list-style-type: none;
  padding: 0;
  
}
li {
  
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>